<template>
  <WdsAlert warning :title="$t('Note')">
    <template #description>
      <p>
        Some jobs in Worksome will require you to either have a registered business, be a registered
        sole trader or work through an umbrella service.
      </p>
      <p>
        <a
          href="https://help.worksome.dk/en/articles/4190692-business-entity-setup-for-freelancers"
          target="_blank"
        >
          Check out our guide for your business entity setup.
          <i class="zmdi zmdi-open-in-new"></i>
        </a>
      </p>
    </template>
  </WdsAlert>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: {
    WdsAlert,
  },
}
</script>
